import Vue from "vue";
import VueZoomer from "vue-zoomer";

export default Vue.use(VueZoomer);
